import type { ReactNode } from "react";

import { ThemeProvider as NextThemesProvider } from "next-themes";

import { THEMES } from "./themeOptions";

/**
 * Постоянный светлый интерфейс, независимо от системы и старого localStorage.theme.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
    return (
        <NextThemesProvider
            attribute="class"
            themes={[THEMES.light]}
            forcedTheme={THEMES.light}
            defaultTheme={THEMES.system}
            enableSystem={false}
            disableTransitionOnChange
        >
            {children}
        </NextThemesProvider>
    );
}
